/*
 * MDB shim for ToastContainer
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Accounts/accountList.jsx
 * - src/Seating/Activities/activities-add.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Activities/activities-list.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/Deliveries/inventoryTracking.jsx
 * - src/Seating/Faxes/faxes.jsx
 * - src/Seating/InventoryProduct/inventoryProductTable.jsx
 * - src/Seating/Orders/ATPView.jsx
 * - src/Seating/Orders/RecurringOrders.jsx
 * - src/Seating/Orders/collectionsView.jsx
 * - src/Seating/Orders/orderList.jsx
 * - src/Seating/Orders/salesPipelineView.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/inventoryRequestTable.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueTable.jsx
 * - src/Seating/Reports/reports.jsx
 * - src/Seating/Settings/addProdcutMatrixEntry.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/productMatrixEntry.jsx
 * - src/Seating/Settings/vendor.jsx
 * - src/Seating/Tasks/taskTable.jsx
 * - src/Seating/Users/thirdPartyUserList.jsx
 * - src/Seating/Users/userAdd.jsx
 * - src/Seating/Users/userEdit.jsx
 */

import { Fragment } from "react";

/*
 * Non-obvious mapping note:
 * Toasts are rendered by the app-level Notistack SnackbarProvider. This remains
 * a no-op so legacy screens can keep their local ToastContainer markup safely.
 */
export default function ToastContainer() {
    return <Fragment />;
}
